module.exports = __webpack_public_path__ + "static/media/lobb_404.65304082.jpg";